/**
 * Forbrukerrådet - Kommunetesten
 * @link https://gitlab01.copyleft.no/FBR/kommunetesten-new
 * @author Anders Evenrud <anders.evenrud@copyleft.no>
 */

import Vue from 'vue'

export const EventBus = new Vue()
